import React, { useState } from 'react';
import MyPie from '../../components/Charts/MyPie';
import TitleMain from "../../components/Title/TitleMain";
import TitleSecondary from "../../components/Title/TitleSecondary";
import MyRing from "../../components/Charts/MyRing";
import EmployeesSexeChart from "../../components/Charts/EmployeesSexeChart";
import MyDonut from "../../components/Charts/MyDonut";
import MyLine from "../../components/Charts/MyLine";
import StrokeContainer from "../../components/Container/StrokeContainer";
import MyRadial from "../../components/Charts/MyRadial";
const ChartsTestPage = props => {

    return (
        <div className="content">
            <TitleMain text={"Mes graphiques"}/>

            <TitleSecondary text={"Vue d'ensemble"}/>

            <MyDonut data={[
                { name: 'Yoga', value: 55, fill: '#7A9A01' },
                { name: 'Cardio', value: 189, fill: '#E03C31' },
                { name: 'Pilates', value: 203, fill: '#004851' },
                { name: 'Training', value: 78, fill: '#A69F88' },
            ]} title={"Salariés"} />

            <StrokeContainer title={"Salariés actifs:"} children={
                <EmployeesSexeChart data={[
                    { label: "Hommes", percentage: 76, color: "#004851", totalEmployees: 50},
                    { label: "Femmes", percentage: 62, color: "#7A9A01",  totalEmployees: 50},
                ]} />
            } />

            <StrokeContainer title={"Cours:"} children={
                <MyLine data={[
                    { semaine: 1, Yoga: 400, Pilates: 240, Cardio: 240, Training: 200 },
                    { semaine: 2, Yoga: 300, Pilates: 139, Cardio: 221, Training: 250},
                    { semaine: 3, Yoga: 200, Pilates: 980, Cardio: 229, Training: 300, Equitation: 50 },
                    { semaine: 4, Yoga: 278, Pilates: 390, Cardio: 200, Training: 350, Equitation: 500 },
                    { semaine: 5, Yoga: 189, Pilates: 480, Cardio: 218, Training: 400, Equitation: 400 },
                ]} xLabel={{key: 'semaine', label: 'Semaines'}} yLabel={{key: 'inscrit', label: 'Inscrits'}} />
            } />

            <StrokeContainer title={"Séance Juin:"} children={
                <MyRing data={[
                    [{ name: 'Yoga', value: 84 }, { name: 'absents', value: 67 }],
                    [{ name: 'Cardio', value: 63 }, { name: 'absents', value: 10 }, { name: 'Malades', value: 20 }],
                    [{ name: 'Pilates', value: 76 }],
                    [{ name: 'Training', value: 76 }]
                ]} />
            } />


            <MyRadial data={[
                { name: 'Yoga', value: 84, total: 1023, fill: '#2c285e' },
                { name: 'Cardio', value: 63, total: 1023, fill: '#006fff' },
                { name: 'Pilates', value: 76, total: 1023, fill: '#ff00cd' },
            ]} />

            <MyPie data={[
                { name: 'Yoga', value: 17, fill: '#8884d8' },
                { name: 'Cardio', value: 13, fill: '#83a6ed' },
                { name: 'Pilates', value: 30, fill: '#8dd1e1' },
                { name: 'Training', value: 20, fill: '#82ca9d' },
            ]} />
        </div>
    );
};

export default ChartsTestPage;
